<template>
  <main id="game"></main>
</template>

<script>
export default {
  name: 'BinaryTextToImage',
  mounted() {
    import('./src/game').then((game) => {
      this.$nextTick(() => {
        window.miniGame = game.launch;
        import('../shared/game-kickoff/game-kickoff-init').then((game2) => {
          window.kickOff = game2.launch;
          window.activeGame = window.kickOff();
        });
        window.addEventListener(
          'popstate',
          () => {
            window.activeGame.destroy(true);
          },
          false,
        );
      });
    });
  },
};
</script>

<style scoped>
#game {
  display: flex;
  justify-content: center;
  height: 100vh;
  overflow: hidden;
}
</style>
